<template>
  <q-btn
    :color="SET_COLOR.primary"
    :label="$t('label.ticketPdf')"
    icon="fal fa-file-pdf"
    style="width:200px;"
    @click="$emit('start-download', ticket)"
  />
</template>

<script>
  export default {
    name: 'DownloadTicketPDFComponent',
    props: {
      ticket: {
        type: Object,
        default: () => {},
      },
    },
  };
</script>
